import React from 'react';
import Save from "../../assets/save.svg";

interface PaginationControlsProps {
    page: number;
    pages: number;
    setPage: (page: number) => void;
    media?: { file?: string };
    file_obj?: { media_info?: { file?: string } };
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
    page,
    pages,
    setPage,
    media,
    file_obj
}) => {
    return (
        <div className="flex w-full justify-center gap-2">
            <button
                className="w-44 p-2 text-black rounded-lg bg-melon-yellow hover:bg-yellow-400 disabled:bg-melon-light-grey"
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
            >
                Назад
            </button>
            <button
                className="w-44 p-2 text-black rounded-lg bg-melon-yellow hover:bg-yellow-400 disabled:bg-melon-light-grey"
                disabled={page === pages}
                onClick={() => setPage(page + 1)}
            >
                Вперед
            </button>
            <a
                className="w-10 p-2 flex flex-row justify-center items-center gap-1 text-black rounded-lg bg-melon-yellow hover:bg-yellow-400"
                href={media?.file || file_obj?.media_info?.file}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={Save} alt="download file" />
            </a>
        </div>
    );
};

export default PaginationControls;
